import { createSvgIconComponent } from "../utils";
export var IconHeartOutline = createSvgIconComponent({
  path: "M17.7008 4.33954C14.2668 3.01688 11.9914 6.06849 11.9914 6.06849C11.9914 6.06849 9.7347 3.00842 6.30068 4.33218C3.37802 5.45758 2.21316 8.81316 3.55237 11.5199C4.69898 13.8359 7.11958 16.8808 11.9914 20.2C16.8649 16.8808 19.3025 13.8432 20.4476 11.5273C21.7868 8.82015 20.6219 5.46494 17.7008 4.33954Z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: "2px",
  fill: "none",
  viewBox: "0 0 24 24"
});